import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { canLoad } from './auth/home-auth.guard';
import { Backend } from './_models/backend';
import { RouterConstants } from './_models/router-constants';
import { PairingComponent } from './pairing/pairing.component';
import { GuestLoginComponent } from './guest-login/guest-login.component';
import Role = Backend.Role;

const studentRoles: Role[] = ['ROLE_STUDENT'];

const routes: Routes = [
  {
    path: RouterConstants.CLASSES,
    loadChildren: () => import('./class-chooser/class-chooser.module').then(m => m.ClassChooserModule),
    canMatch: [canLoad],
    data: {roles: studentRoles}
  },
  {
    path: RouterConstants.HOME,
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canMatch: [canLoad],
    data: {roles: studentRoles}
  },
  {
    path: RouterConstants.HOMEWORK_ID,
    loadChildren: () => import('./homework/homework.module').then(m => m.HomeworkModule),
    canMatch: [canLoad],
    data: {roles: studentRoles}
  },
  {
    path: RouterConstants.HOMEWORK,
    loadChildren: () => import('./homework/homework.module').then(m => m.HomeworkModule),
    canMatch: [canLoad],
    data: {roles: studentRoles}
  },
  {path: RouterConstants.LOGIN, component: LoginComponent},
  {path: RouterConstants.PAIRING, component: PairingComponent},
  {path: RouterConstants.GUEST_LOGIN, component: GuestLoginComponent},
  {path: RouterConstants.GUEST_LOGIN_CODE, component: GuestLoginComponent},
  {path: '', redirectTo: RouterConstants.CLASSES, pathMatch: 'full'},
  {path: '**', redirectTo: RouterConstants.CLASSES}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
